
import { PropertyPath } from 'lodash';
import Vue, {PropOptions} from 'vue';
import { getImageSize, isElemOverflown } from '~/lib/util/dom_utils';

type Photo = GalleryPhoto | {photo_url: string};

type Action = {
  id: string,
  text: string,
  action: (photo: Photo) => void,
  class?: string
};

export default Vue.extend({
  props: {
    arrows: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => [] as Action[]
    } as PropOptions<Action[]>,
    flavour: {
      type: String,
      default: 'dark-overlay',
    } as PropOptions<'dark-overlay' | 'white-popup'>,
  },
  data() {
    return {
      photo: undefined,
      video: undefined,
      isOverflown: false
    } as {
      photo: Photo | undefined
      video: YoutubeVideoProps | undefined
      isOverflown: boolean
    }
  },
  mounted() {
    this.$on('open_preview', async (photo: Photo) => {
      if(this.photo) {
        const $img = this.$refs.photo as HTMLImageElement;
        if($img) {
          $img.onload = null;
        }
      }

      this.photo = photo;
      await this.$nextTick();

      const $img = this.$refs.photo as HTMLImageElement;

      $img.onload = async () => {
        if($img) {
          $img.onload = null;
          this.isOverflown = false;
          await this.$nextTick();
          this.isOverflown = isElemOverflown(this.$refs.photoOuter as HTMLElement);
          console.log(`isOverflown`, this.isOverflown)
        }
      };

      // this.isOverflown = isElemOverflown(this.$refs.photoOuter as HTMLElement);
      // const {aspectRatio} = await getImageSize(photo.photo_url);
      // this.aspectRatio = aspectRatio;
      // console.log(`aspectRatio ->`, aspectRatio)
    });

    this.$on('open_video_preview', async (video: YoutubeVideoProps) => {
      console.log(`open_video_preview`, video);
      this.video = video;

      // TODO: do we need to check for overflowing here? Everything seems to be
      //   working without it.
    });

    this.$on('close_preview', async () => {
      const $img = this.$refs.photo as HTMLImageElement;
      this.photo = undefined;
      this.video = undefined;
      this.isOverflown = false;

      if($img) {
        $img.onload = null;
      }
    });
  },
  computed: {
    overlayVisible() {
      // @ts-ignore
      return this.photo !== undefined || this.video !== undefined;
    }
  },
  methods: {
    $emit_if_photo(eventName: string, photo: Photo) {
      if(this.photo !== undefined) {
        this.$emit(eventName, photo);
      } else {
        console.warn(`Event ${eventName} not supported when photo is not set`);
      }
    }
  }
})
